import { render, staticRenderFns } from "./UtilPlaceholderHitCard.vue?vue&type=template&id=cb8da600&scoped=true"
import script from "./UtilPlaceholderHitCard.vue?vue&type=script&lang=js"
export * from "./UtilPlaceholderHitCard.vue?vue&type=script&lang=js"
import style0 from "./UtilPlaceholderHitCard.vue?vue&type=style&index=0&id=cb8da600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8da600",
  null
  
)

export default component.exports